import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';
import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { ConfidenceScale } from '@ctw/shared/components/indicators/confidence-scale';
import { useBuilderConfig } from '@ctw/shared/context/builder-config-context';
import { tw } from '@ctw/shared/utils/tailwind';
import { compact } from 'lodash-es';

export interface RiskGapDetailsCardProps {
  riskGap: RiskGapModel;
}

export const RiskGapDetailsCard = ({ riskGap }: RiskGapDetailsCardProps) => {
  const builderConfig = useBuilderConfig();

  return (
    <ContentCard variant="focal" title="Details">
      <DefinitionList
        className={tw`pt-2 pb-0`}
        items={compact([
          { label: 'HCC', value: riskGap.hccCode },
          { label: 'Source', value: riskGap.gapSourceListDisplay },
          { label: 'Status', value: riskGap.statusDisplay },
          builderConfig.riskGaps?.showConfidenceLevels && {
            label: 'Confidence',
            value: <ConfidenceScale confidenceLevel={riskGap.confidenceRating} />,
          },
          {
            label: 'Matching ICD-10',
            value: (
              <ul className={tw`flex flex-col gap-2`}>
                {riskGap.icd10Codes.map((code) => (
                  <li
                    key={code.code}
                    style={{ textIndent: `-${code.code.length - 1}cw` }}
                    className={tw`leading-tight`}
                  >
                    <span className={tw`font-medium text-base text-content-main`}>
                      {code.code}&nbsp;
                    </span>
                    <span className={tw`text-base text-content-main`}>{code.display}</span>
                  </li>
                ))}
              </ul>
            ),
          },
        ])}
      />
    </ContentCard>
  );
};
